export const buttonGroupData = ["secondary", "success", "info", "warning", "danger", "light", "dark"];

export const radioButtonGroupData = [
  {
    text: "Add ",
    code: ".active",
  },
  {
    text: " for active state and",
    code: ".disabled",
  },
  {
    text: " class or ",
    code: "disabled='disabled'",
  },
  {
    text: " attribute",
  },
];

export const radiobuttonDataList = [
  {
    idOne: 3,
    idTwo: 4,
    color: "secondary",
    name: "radio-2",
  },
  {
    idOne: 5,
    idTwo: 6,
    color: "success",
    name: "radio-3",
  },
  {
    idOne: 7,
    idTwo: 8,
    color: "info",
    name: "radio-4",
  },
  {
    idOne: 9,
    idTwo: 10,
    color: "warning",
    name: "radio-5",
  },
  {
    idOne: 11,
    idTwo: 12,
    color: "danger",
    name: "radio-6",
  },
  {
    idOne: 13,
    idTwo: 14,
    color: "light",
    name: "radio-7",
  },
];

export const checkboxButtonGroupData = [
  {
    text: "Add ",
    code: ".active",
  },
  {
    text: " for active state and",
    code: ".disabled",
  },
  {
    text: " class or ",
    code: "disabled='disabled'",
  },
  {
    text: " attribute",
  },
];

export const checkboxButtonDataList = [
  {
    idOne: 3,
    idTwo: 4,
    color: "secondary",
  },
  {
    idOne: 5,
    idTwo: 6,
    color: "success",
  },
  {
    idOne: 7,
    idTwo: 8,
    color: "info",
  },
  {
    idOne: 9,
    idTwo: 10,
    color: "warning",
  },
  {
    idOne: 11,
    idTwo: 12,
    color: "danger",
  },
  {
    idOne: 13,
    idTwo: 14,
    color: "light",
  },
];

export const nestingData = [
  {
    text: "Make nesting buttons",
  },
];

export const nestingDataList=["md","lg"]

export const verticalButtonGroup = [
  {
    text: "Make vertical buttons",
  },
];